import { translateDomain } from '../../../utils/labels_utils';

export const tableControls = (t) => [
  { id: "scfControl", type: "text", label: t('gap-analysis:table.control'), sortable: true },
  {
    id: "scfDomain",
    type: "dropdown",
    label: t('gap-analysis:table.domain'),
    sortable: true,
    format: (v) => (v ? translateDomain(t, v) : ''),
  },
  { id: "controlWeighting", type: "number", label: t('gap-analysis:table.controlWeight'), sortable: true },
  { id: "status", label: t('common:labels.status'), type: "status" },
  { id: "maturity_level", label: t('gap-analysis:table.maturityLevel'), type: "maturity-level" },
  { id: "actions-view", type: "actions-view", label: "" },
];
